// @ts-nocheck
import React from "react";
import {
  withStyles,
  Grid,
  Typography,
  createStyles,
  Button,
} from "@material-ui/core";
import { withRouter, RouterProps } from "react-router";
import withAlertBox, {
  withAlertBoxProps,
} from "../../../../components/src/withAlertBox.Web";
import withToast, {
  withToastProps,
} from "../../../../components/src/withSnackBar.Web";
import withLoader, {
  withLoaderProps,
} from "../../../../components/src/withLoader.Web";
import withDialogBox from "../../../../components/src/withDialog.web";
import { DialogProps } from "../../../../components/src/DialogContext";

export type Props = RouterProps &
  DialogProps &
  withAlertBoxProps &
  withToastProps &
  withLoaderProps & {
    id: string;
  };

export class ConfirmDialog extends React.Component {
  constructor(props: Props) {
    super(props);
  }

  closeDialog = (data) => {
    this.props.onSubmit(data);
  };

  render() {
    const { classes, dataToPass } = this.props;
    return (
      <Grid
        container
        justifyContent="space-between"
        className={classes.rootContainer}
      >
        <Grid item xs={12}>
          <Typography align="center" className={classes.dialogHeading}>
            {dataToPass.message}
          </Typography>
        </Grid>

        <Grid item xs={6} className={classes.buttonContainer}>
          <Button
            variant="contained"
            color="secondary"
            fullWidth
            className={classes.actionButton}
            onClick={this.closeDialog.bind(this, null)}
          >
            {dataToPass.cancelLabel || "Cancel"}
          </Button>
        </Grid>
        <Grid item xs={6} className={classes.buttonContainer}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            className={classes.actionButton}
            onClick={this.closeDialog.bind(this, "Yes")}
          >
            {dataToPass.confirmLabel || "Yes"}
          </Button>
        </Grid>
      </Grid>
    );
  }
}

const ConfirmDialogWithRouter = withRouter(ConfirmDialog);
const ConfirmDialogWithToast = withToast(ConfirmDialogWithRouter);
const ConfirmDialogWithLoader = withLoader(ConfirmDialogWithToast);
const ConfirmDialogWithAlertBox = withAlertBox(ConfirmDialogWithLoader);
const ConfirmDialogWithDialogBox = withDialogBox(ConfirmDialogWithAlertBox);

export default withStyles((theme) =>
  createStyles({
    rootContainer: {
      padding: "1rem",
    },
    dialogHeading: {
      fontSize: "1.35rem",
      fontWeight: "bold",
      color: theme.palette.text.secondary,
      marginBottom: "1.2rem",
      marginTop: "1rem",
    },
    buttonContainer: {
      padding: "0 1.5rem",
    },
    actionButton: {
      margin: "1rem 0px",
    },
  })
)(ConfirmDialogWithDialogBox);
